import {React} from "react";
import './JButton.scss'

const JButton = ({handleClick,title,leftIcon,rightIcon,type,noSize,href,width,height,iconImage,disabled}) => {
    return ( 
        <div className={`btnContainerP${disabled ? " disabled" : "" }`}>
            <div className={`btnContainer${type}`} style={{width: noSize ? "100%" : (width!=null ? width : "162px"),height: noSize ? "100%" : (height!=null ? height :"48px")}} onClick={handleClick}>
                <a href={href!=null ? href : ""} target={href!=null ? "_blank" : ""}>
                    {rightIcon!=null ? <div className={rightIcon}></div> : null}
                    {title}
                    {leftIcon!=null ? (iconImage===undefined ? <div className={leftIcon}></div> : <span/>) : null}
                </a>
            </div>
        </div>
    );
}

export default JButton;
